var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F8E4C5"
    },
    cx: 256,
    cy: 255.999,
    r: 255.999
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126.685,
    y: 252.387,
    transform: "matrix(-0.454 -0.891 0.891 -0.454 -86.4983 582.176)",
    width: 16.885,
    height: 130.408
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.154,
    y: 149.622,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 158.0822 381.6095)",
    width: 109.841,
    height: 16.885
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 310.287,
    y: 74.241,
    transform: "matrix(-0.891 -0.454 0.454 -0.891 542.3925 395.9737)",
    width: 16.885,
    height: 117.272
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 335.008,
    y: 268.924,
    transform: "matrix(-0.9877 -0.1564 0.1564 -0.9877 733.7955 612.471)",
    width: 111.971,
    height: 16.885
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 207.433,
    y: 383.522,
    transform: "matrix(-0.1564 -0.9877 0.9877 -0.1564 -66.208 727.381)",
    width: 140.191,
    height: 16.885
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272F37"
    },
    d: "M184.008,195.562l-15.153,95.667c-0.942,5.95,2.054,11.832,7.423,14.567l86.303,43.973 c5.368,2.735,11.887,1.703,16.148-2.558l68.49-68.49c4.261-4.261,5.293-10.779,2.557-16.148l-43.973-86.303 c-2.735-5.368-8.616-8.365-14.567-7.423l-95.667,15.153C189.617,184.943,184.95,189.61,184.008,195.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272F37"
    },
    d: "M151.927,22.054C124.018,34.461,97.87,52.092,74.982,74.981 c-22.886,22.886-40.517,49.034-52.924,76.94l102.134-16.176c5.95-0.942,10.618-5.609,11.561-11.561L151.927,22.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272F37"
    },
    d: "M1.408,282.718c5.879,56.347,30.392,111.12,73.574,154.302c3.189,3.189,6.443,6.273,9.754,9.259 l16.168-102.08c0.942-5.95-2.054-11.832-7.423-14.567L1.408,282.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272F37"
    },
    d: "M282.728,1.407l46.911,92.068c2.735,5.368,8.616,8.365,14.567,7.423l102.071-16.167 c-2.984-3.311-6.067-6.563-9.255-9.751C393.841,31.801,339.073,7.288,282.728,1.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272F37"
    },
    d: "M202.722,506.41c61.068,12.934,125.939,3.363,181.367-28.706l-92.129-46.941 c-5.368-2.735-11.887-1.703-16.148,2.558L202.722,506.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272F37"
    },
    d: "M477.709,384.08c32.066-55.427,41.635-120.294,28.701-181.359l-73.085,73.085 c-4.261,4.261-5.293,10.779-2.557,16.148L477.709,384.08z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M375.093,29.351c-12.333,15.939-19.691,35.923-19.691,57.636 c0,52.076,42.216,94.291,94.291,94.291c17.133,0,33.182-4.592,47.028-12.578C474.889,108.514,431.127,58.854,375.093,29.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    d: "M282.3,485.7c-141.385,0-256-114.615-256-256 c0-63.999,23.486-122.512,62.308-167.393C34.34,109.249,0.001,178.614,0.001,256c0,141.385,114.615,256,256,256 c77.386,0,146.75-34.338,193.692-88.607C404.812,462.214,346.3,485.7,282.3,485.7z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.fcc475f3296fd8076a53fb15c6c4570a.svg";
export { ForwardRef as ReactComponent };